import { render } from "./homeweb.vue?vue&type=template&id=0d697c54&scoped=true"
import script from "./homeweb.vue?vue&type=script&lang=js"
export * from "./homeweb.vue?vue&type=script&lang=js"

import "./homeweb.vue?vue&type=style&index=0&id=0d697c54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d697c54"]])

export default __exports__